import { Button, type ButtonProps } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";

/** A light "download this blob" button; the blob endpoint is anonymous so a plain anchor suffices. */
export default function DownloadButton({ href, label = "Download", ...props }: { href: string; label?: string } & ButtonProps) {
  return (
    <Button
      component="a"
      href={href}
      download
      variant="light"
      size="xs"
      leftSection={<IconDownload size={14} />}
      {...props}
    >
      {label}
    </Button>
  );
}
